import UpdateService from "./UpdateService";

export default class UpdateItem {
	id: string;
	count: number;
	services: Array<UpdateService>;

	constructor(id? : string, count?: number) {
		this.id = id;
		this.count = count;
		this.services = new Array<UpdateService>();
	}
}
